import { render } from "./form-wizard.vue?vue&type=template&id=0f05928a"
import script from "./form-wizard.vue?vue&type=script&lang=js"
export * from "./form-wizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__